.highScores {
    margin: 0 15px;
    overflow-x: auto;
    table {
        width: 100%;
        tr {
            border-top: 1px var(--secondary) solid;
        }
        thead > tr {
            border-bottom: 2px var(--primary) solid;
        }
        td {
            padding: 3px;
            padding-right: 8px;
        }
    }
}
